import { useState } from 'react';

export default function HeroSection() {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      window.open(`https://www.baidu.com/s?wd=${encodeURIComponent(searchTerm)}`, '_blank');
    }
  };

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20organic%20shapes%20in%20coral%20and%20terracotta%20tones%2C%20minimalist%20geometric%20patterns%2C%20elegant%20modern%20design%2C%20clean%20composition%2C%20subtle%20texture%2C%20warm%20atmospheric%20lighting%2C%20no%20text%2C%20no%20blue%2C%20no%20purple&width=1600&height=900&seq=hero-bg-91-url&orientation=landscape"
          alt="91网址导航背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
            精选网址导航
            <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-3 text-background-50/85">
              您的每日上网最佳起点
            </span>
          </h1>
          <p className="text-base md:text-lg text-background-50/75 mb-10 max-w-2xl mx-auto leading-relaxed">
            汇聚海量精选优质网址，涵盖生活、娱乐、工具、学习等十大类别。告别繁琐搜索，一键直达心仪网站
          </p>

          <form onSubmit={handleSearch} className="max-w-xl mx-auto relative">
            <div className="flex items-center bg-background-50 rounded-lg overflow-hidden">
              <span className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-search-line text-foreground-400 text-lg"></i>
              </span>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="搜索网站名称或关键词..."
                className="flex-1 h-12 bg-transparent text-foreground-950 text-sm outline-none placeholder:text-foreground-400"
              />
              <button
                type="submit"
                className="whitespace-nowrap cursor-pointer h-12 px-6 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-colors"
              >
                搜 索
              </button>
            </div>
          </form>

          <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
            <span className="text-xs text-background-50/60">热门搜索：</span>
            {['百度', '淘宝', 'B站', '知乎', '京东', '网易云音乐'].map((term) => (
              <button
                key={term}
                onClick={() => setSearchTerm(term)}
                className="text-xs text-background-50/75 hover:text-background-50 transition-colors bg-background-50/10 hover:bg-background-50/20 px-3 py-1 rounded-full cursor-pointer whitespace-nowrap"
              >
                {term}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}